import { PAGE_TYPE } from "app/umbraco/pages/page.types";
import OverlayRootState from "layout/models/redux-state.interface";

export default (currentPage: PAGE_TYPE, styles: any, overlay?: OverlayRootState): string | undefined => {
    if (overlay?.currentOverlay === "COUNTRIES_MENU") {
        return styles.is_open;
    }

    return undefined;
};
